module.exports = __webpack_public_path__ + "static/media/bq.c109cd67.svg";